// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"97851061","239":"8831a8cd","453":"1fb66f14","732":"cb0416ba"}[chunkId] + ".chunk.js";
};